import Link from 'next/link';
import { memo } from 'react';
import useHover from '../../hooks/useHover';
import useWindowWidth from '../../hooks/useWindowWidth';
import AccordionFooterStoriesMenu from '../ui/accordion/AccordionFooterStoriesMenu';
import AccordionFooterSubMenu from '../ui/accordion/AccordionFooterSubMenu';
import ArrowZ from '../icon/ArrowZ';
import ArrowX from '../icon/ArrowX';
import Img from '../section/common/Img';
import storiesCategoryItems from '../section/stories/storiesCategoryItems';
import { navSubHelpItems } from '../common/navMenuItems';
import { navSubCareersItems } from '../common/navMenuItems';
import { navSubCorporateItems } from '../common/navMenuItems';
import styles from '../../styles/components/common/Footer.module.scss';
import dayjs from 'dayjs';

const Footer = memo(() => {
    useHover();
    const { breakPoint, windowWidth } = useWindowWidth();

    return (
        <footer className={styles.container}>
            <div className={styles.wrapper}>
                {/* info */}
                <div className={styles.info}>
                    {/* news letter */}
                    <section
                        className={`${styles.infoSection} ${styles.infoNews}`}
                    >
                        <h2 className={styles.infoSectionTitle}>
                            JOIN OUR <br className="u-none__pc" />
                            NEWSLETTER
                        </h2>
                        <p className={styles.infoSectionText}>
                            限定クーポンやおすすめメニュー、CRISPの新店舗のオープン情報が知りたいって？{' '}
                            <br />
                            OK、NEWSLETTERを用意しました。
                        </p>
                        <div className="mailchimp" id="mc_embed_signup">
                            <form
                                className="validate"
                                action="https://crisp.us20.list-manage.com/subscribe/post?u=f31e7d37d2b73d7d30d5e1924&amp;id=1a2305fe3f"
                                method="post"
                                id="mc-embedded-subscribe-form"
                                name="mc-embedded-subscribe-form"
                                target="_blank"
                                noValidate
                            >
                                <div
                                    className={styles.infoSectionMail}
                                    id="mc_embed_signup_scroll"
                                >
                                    <label
                                        className={styles.infoSectionMailLabel}
                                        htmlFor="mce-EMAIL"
                                    >
                                        SUBSCRIBE
                                    </label>
                                    <input
                                        className={`${styles.infoSectionMailInput} email`}
                                        id="mce-EMAIL"
                                        type="email"
                                        name="EMAIL"
                                        placeholder="YOUR EMAIL"
                                        required
                                        defaultValue={''}
                                    />
                                    <div
                                        aria-hidden="true"
                                        className={
                                            styles.infoSectionMailHiddenInput
                                        }
                                    >
                                        <input
                                            type="text"
                                            name="b_f31e7d37d2b73d7d30d5e1924_1a2305fe3f"
                                            tabIndex="-1"
                                            defaultValue=""
                                        />
                                    </div>
                                    <div
                                        className={`${styles.infoSectionMailButton} js-hover js-hover__btn__point`}
                                    >
                                        <ArrowX color="#f9f8f3" />
                                        <input
                                            className={
                                                styles.infoSectionMailButtonSubscribe
                                            }
                                            data-hover-in-time="600"
                                            data-hover-out-time="0"
                                            id="mc-embedded-subscribe"
                                            type="submit"
                                            defaultValue="SUBSCRIBE"
                                            name="subscribe"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>
                    {/* app */}
                    <section
                        className={`${styles.infoSection} ${styles.infoApp}`}
                    >
                        <h2 className={styles.infoSectionTitle}>
                            HELLO! <br className="u-none__pc" />
                            CRISP APP
                        </h2>
                        <p className={styles.infoSectionText}>
                            そうそう、CRISP APP
                            があれば、自宅でもオフィスでも思いついた時にいつでもスマホからあなただけのサラダを自由自在に注文できるんですよ。
                        </p>
                        <Link
                            href="/app"
                            className={`${styles.infoSectionButton} js-hover js-hover__btn__point`}>

                            <span className={styles.infoSectionButtonText}>
                                GET CRISP APP!
                            </span>

                        </Link>
                        <div className={styles.infoSectionImg}>
                            <Link href="/app" className={styles.infoSectionImgLink} aria-label="crisp app">

                                {windowWidth > breakPoint ? (
                                    <video
                                        src="/image/common/footer_iphone.mp4"
                                        className={`${styles.infoSectionImgInside} u-none__sp`}
                                        autoPlay
                                        loop
                                        muted
                                    ></video>
                                ) : (
                                    <Img
                                        src="/image/common/footer_iphone.png"
                                        webpSrc="/image/common/footer_iphone.webp"
                                        alt="HELLO! CRISP APP"
                                    />
                                )}

                            </Link>
                        </div>
                    </section>
                </div>

                {/* main */}
                <div className={styles.main}>
                    <nav className={styles.nav}>
                        {/* menu */}
                        <ul className={styles.navList}>
                            <AccordionFooterSubMenu
                                items={navSubHelpItems}
                                title="HELP"
                                have={false}
                                size="md"
                            />
                            <AccordionFooterStoriesMenu
                                items={storiesCategoryItems}
                                title="STORIES"
                                size="md"
                            />
                            <AccordionFooterSubMenu
                                items={navSubCareersItems}
                                title="CAREERS"
                                have={true}
                                size="sm"
                            />
                            <AccordionFooterSubMenu
                                items={navSubCorporateItems}
                                title="CORPORATE"
                                have={false}
                                size="sm"
                            />
                        </ul>
                        {/* sns */}
                        <div className={styles.navSns}>
                            <ul className={styles.navSnsList}>
                                <li className={styles.navSnsItem}>
                                    <a
                                        className={`${styles.navSnsLink} js-hover`}
                                        aria-label="instagram"
                                        href="https://www.instagram.com/crispsaladworks/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <svg
                                            className={`${styles.navSnsSvg} ${styles.navSnsSvgInstagram} footerNavSnsSvg`}
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.99928 1.62289C11.4023 1.62289 11.6867 1.63217 12.6359 1.6754C13.5132 1.71541 13.9897 1.86187 14.307 1.98512C14.6983 2.12922 15.0523 2.35933 15.3429 2.65849C15.6421 2.94907 15.8722 3.30309 16.0163 3.69445C16.1395 4.01167 16.286 4.48821 16.326 5.36556C16.3692 6.31472 16.3785 6.59907 16.3785 9.00214C16.3785 11.4052 16.3692 11.6896 16.326 12.6387C16.286 13.5161 16.1395 13.9926 16.0163 14.3098C15.8664 14.6979 15.637 15.0502 15.3429 15.3444C15.0488 15.6385 14.6964 15.8679 14.3084 16.0177C13.9912 16.141 13.5146 16.2874 12.6373 16.3275C11.6885 16.3707 11.4038 16.38 9.0007 16.38C6.59764 16.38 6.31292 16.3707 5.36413 16.3275C4.48678 16.2874 4.01024 16.141 3.69302 16.0177C3.30166 15.8736 2.94763 15.6435 2.65706 15.3444C2.3579 15.0538 2.12779 14.6998 1.98368 14.3084C1.86044 13.9912 1.71398 13.5146 1.67397 12.6373C1.63074 11.6881 1.62146 11.4038 1.62146 9.00072C1.62146 6.59764 1.63074 6.31329 1.67397 5.36413C1.71398 4.48678 1.86044 4.01024 1.98368 3.69302C2.12779 3.30166 2.3579 2.94764 2.65706 2.65706C2.94763 2.3579 3.30166 2.12779 3.69302 1.98369C4.01024 1.86044 4.48678 1.71398 5.36413 1.67397C6.31328 1.63075 6.59764 1.62146 9.0007 1.62146L8.99928 1.62289ZM9.0007 0C6.55655 0 6.25005 0.0103596 5.29018 0.0542986C4.33031 0.0982377 3.67659 0.251488 3.10502 0.473684C2.50438 0.69979 1.96021 1.05404 1.51036 1.51179C1.05261 1.96164 0.698361 2.50581 0.472255 3.10645C0.250059 3.67802 0.0978803 4.33317 0.0542986 5.2909C0.0107168 6.24863 0 6.55656 0 9.00072C0 11.4449 0.0103596 11.7514 0.0542986 12.7112C0.0982376 13.6711 0.250059 14.3234 0.472255 14.895C0.698452 15.4954 1.0527 16.0393 1.51036 16.4889C1.96005 16.9469 2.50426 17.3013 3.10502 17.5274C3.67659 17.7499 4.33174 17.9021 5.28947 17.9457C6.24719 17.9893 6.55584 18 8.99999 18C11.4441 18 11.7506 17.9896 12.7105 17.9457C13.6704 17.9018 14.322 17.7499 14.8935 17.5274C15.4916 17.2963 16.0347 16.9428 16.488 16.4895C16.9413 16.0361 17.2949 15.493 17.5259 14.895C17.7485 14.3234 17.9007 13.6683 17.9443 12.7105C17.9878 11.7528 17.9986 11.4442 17.9986 9C17.9986 6.55585 17.9882 6.24935 17.9443 5.28947C17.9003 4.3296 17.7485 3.67802 17.5259 3.10645C17.3 2.50601 16.9459 1.96206 16.4882 1.5125C16.0384 1.0545 15.4942 0.7 14.8935 0.473684C14.322 0.251488 13.6668 0.0993094 12.7091 0.0557276C11.7514 0.0121457 11.4434 0.00142891 8.99928 0.00142891L9.0007 0Z"
                                                fill="#F9F8F3"
                                            />
                                            <path
                                                d="M8.99928 4.38037C8.08531 4.38037 7.19187 4.65139 6.43193 5.15917C5.67199 5.66694 5.0797 6.38866 4.72994 7.23305C4.38018 8.07745 4.28866 9.0066 4.46697 9.903C4.64528 10.7994 5.08539 11.6228 5.73167 12.2691C6.37794 12.9154 7.20134 13.3555 8.09774 13.5338C8.99415 13.7121 9.9233 13.6206 10.7677 13.2708C11.6121 12.9211 12.3338 12.3288 12.8416 11.5688C13.3494 10.8089 13.6204 9.91544 13.6204 9.00147C13.6204 8.39461 13.5009 7.79368 13.2687 7.233C13.0365 6.67232 12.6961 6.16287 12.267 5.73376C11.8379 5.30464 11.3284 4.96425 10.7678 4.73204C10.2071 4.49982 9.60614 4.38032 8.99928 4.38037ZM8.99928 12.0022C8.40579 12.0022 7.82563 11.8262 7.33217 11.4965C6.8387 11.1668 6.45409 10.6981 6.22698 10.1498C5.99986 9.60149 5.94044 8.99814 6.05622 8.41606C6.172 7.83398 6.45779 7.2993 6.87745 6.87965C7.29711 6.45999 7.83178 6.1742 8.41387 6.05841C8.99595 5.94263 9.59929 6.00206 10.1476 6.22917C10.6959 6.45629 11.1646 6.8409 11.4943 7.33436C11.824 7.82783 12 8.40799 12 9.00147C12 9.79731 11.6838 10.5606 11.1211 11.1233C10.5584 11.686 9.79512 12.0022 8.99928 12.0022Z"
                                                fill="#F9F8F3"
                                            />
                                            <path
                                                d="M13.8034 5.27649C14.3998 5.27649 14.8833 4.79301 14.8833 4.1966C14.8833 3.60019 14.3998 3.1167 13.8034 3.1167C13.207 3.1167 12.7235 3.60019 12.7235 4.1966C12.7235 4.79301 13.207 5.27649 13.8034 5.27649Z"
                                                fill="#F9F8F3"
                                            />
                                        </svg>
                                    </a>
                                </li>
                                <li className={styles.navSnsItem}>
                                    <a
                                        className={`${styles.navSnsLink} js-hover`}
                                        aria-label="twitter"
                                        href="https://twitter.com/crispsaladworks"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                      <svg
                                        className={`${styles.navSnsSvg} ${styles.navSnsSvgTwitter} footerNavSnsSvg`}
                                        width="19"
                                        height="20"
                                        viewBox="0 0 1200 1227"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                                          fill="white"/>
                                      </svg>
                                    </a>
                                </li>
                                <li className={styles.navSnsItem}>
                                    <a
                                        className={`${styles.navSnsLink} js-hover`}
                                        aria-label="facebook"
                                        href="https://www.facebook.com/crispsaladworks"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <svg
                                            className={`${styles.navSnsSvg} ${styles.navSnsSvgFacebook} footerNavSnsSvg`}
                                            viewBox="0 0 19 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M18.11 9.055C18.11 4.05406 14.0559 0 9.055 0C4.05406 0 0 4.05406 0 9.055C0 13.5745 3.31127 17.3207 7.64016 18V11.6725H5.34104V9.055H7.64016V7.06007C7.64016 4.79066 8.99204 3.53711 11.0604 3.53711C12.0508 3.53711 13.0873 3.71397 13.0873 3.71397V5.94235H11.9455C10.8207 5.94235 10.4698 6.64039 10.4698 7.35719V9.055H12.9812L12.5797 11.6725H10.4698V18C14.7987 17.3207 18.11 13.5745 18.11 9.055Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </a>
                                </li>
                                <li className={styles.navSnsItem}>
                                    <a
                                        className={`${styles.navSnsLink} js-hover`}
                                        aria-label="note"
                                        href="https://note.com/crispsaladworks/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <svg
                                            className={`${styles.navSnsSvg} ${styles.navSnsSvgNote} footerNavSnsSvg`}
                                            viewBox="0 0 15 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M5.39161 5.42127V4.19786C5.38282 4.05897 5.39824 3.9196 5.43718 3.78608C5.49179 3.62612 5.59457 3.48734 5.73117 3.38909C5.86777 3.29085 6.03138 3.23804 6.19917 3.23804C6.36697 3.23804 6.53058 3.29085 6.66718 3.38909C6.80378 3.48734 6.90655 3.62612 6.96117 3.78608C6.9997 3.91968 7.01511 4.05898 7.00674 4.19786V6.08402C7.01088 6.19512 7.00325 6.30635 6.98395 6.41582C6.94716 6.56238 6.8716 6.69612 6.76535 6.8028C6.65909 6.90948 6.52612 6.98509 6.3806 7.02157C6.27202 7.04102 6.1617 7.04872 6.0515 7.04454H4.17478C4.03647 7.05296 3.89776 7.03742 3.76467 6.9986C3.6058 6.94447 3.46778 6.84149 3.37001 6.70413C3.27224 6.56678 3.21966 6.40197 3.21966 6.2329C3.21966 6.06384 3.27224 5.89903 3.37001 5.76168C3.46778 5.62432 3.6058 5.52133 3.76467 5.46721C3.89783 5.42877 4.03653 5.41352 4.17478 5.42212L5.39161 5.42127ZM12.0791 13.9732H2.01368V5.06054C2.01276 5.00642 2.02284 4.95268 2.04331 4.90264C2.06377 4.8526 2.09418 4.80732 2.13266 4.76958L4.74353 2.14579C4.78106 2.10689 4.82612 2.07617 4.87591 2.05554C4.92569 2.0349 4.97915 2.02479 5.03297 2.02584H12.0791V13.9732ZM13.2225 0.0112079C13.1384 0.00288404 13.0539 -0.000808534 12.9694 0.000147476H4.76547C4.67518 0.000147476 4.58404 0.0061033 4.5216 0.0112079C4.1497 0.0509859 3.80365 0.221815 3.54442 0.493597L0.489687 3.56318C0.219885 3.82357 0.0506126 4.17213 0.0120679 4.54667C0.00616095 4.60963 0.000254053 4.70066 0.000254053 4.79255V14.8699C-0.0010836 14.9552 0.002862 15.0404 0.0120679 15.1252C0.0437089 15.343 0.14437 15.5448 0.299033 15.7002C0.453696 15.8557 0.65407 15.9566 0.870263 15.9879C0.954325 15.9971 1.03887 16.001 1.12342 15.9998H12.9719C13.0565 16.001 13.141 15.9971 13.2251 15.9879C13.4414 15.9568 13.642 15.856 13.7968 15.7005C13.9516 15.545 14.0524 15.3432 14.0841 15.1252C14.0924 15.0404 14.0961 14.9552 14.0951 14.8699V1.12827C14.0961 1.04306 14.0924 0.957849 14.0841 0.87304C14.0521 0.654828 13.9509 0.452931 13.7956 0.29757C13.6403 0.142209 13.4392 0.0417412 13.2225 0.0112079Z"
                                                fill="#F9F8F3"
                                            />
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>

                    <div className={styles.navSub}>
                        <ul className={styles.navSubList}>
                            <li className={styles.navSubItem}>
                                <a
                                    className={`${styles.navSubItemLink} js-hover`}
                                    data-hover-in-time="600"
                                    data-hover-out-time="0"
                                    href="https://r.crisp.co.jp/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span
                                        className={`${styles.navSubItemText} js-hover__opacity`}
                                    >
                                        PRIVACY POLICY
                                    </span>
                                    <ArrowZ color="#f9f8f3" />
                                </a>
                            </li>
                            <li className={styles.navSubItem}>
                                <a
                                    className={`${styles.navSubItemLink} js-hover`}
                                    data-hover-in-time="600"
                                    data-hover-out-time="0"
                                    href="https://r.crisp.co.jp/term-of-use"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span
                                        className={`${styles.navSubItemText} js-hover__opacity`}
                                    >
                                        TERM OF USE
                                    </span>
                                    <ArrowZ color="#f9f8f3" />
                                </a>
                            </li>
                        </ul>
                        <small className={styles.navSubSmall}>
                            © {dayjs(new Date()).year()} CRISP
                        </small>
                    </div>
                </div>

                {/* logo */}
                <div className={styles.logo}>
                    <img
                        src="/image/logo/tertiary_logo_1_white.svg"
                        alt="CRISP SALAD WORKS"
                        className={styles.logoSvg}
                    />
                </div>
            </div>
        </footer>
    );
});

Footer.displayName = 'Footer';

export default Footer;
